/* eslint-disable */
import angular from 'angular'
import * as _ from 'lodash'
import { StateRequest } from './publishActions.dataTypes'
import intl from 'react-intl-universal'

export default ['$scope', 'locklessService', publishActionsCalCtrl]
function publishActionsCalCtrl($scope, locklessService) {
  this.intl = intl
  // Return a difference between JS date and `todayDate`, which depends on `defaultTimezone`
  const getDiffWithToday = (date) => {
    const momentDate = moment.tz(
      [date.getFullYear(), date.getMonth(), date.getDate()],
      this.defaultTimezone
    )
    return momentDate.diff(this.todayDate)
  }
  this.showMeridian = true
  locklessService.fetchOrgSettings().then(
    function fetchOrgSettings(orgSettings) {
      if (_.get(orgSettings, 'clockFormat') === '24') {
        this.showMeridian = false
      } else if (_.get(orgSettings, 'clockFormat') === '12') {
        this.showMeridian = true
      }
    }.bind(this)
  )

  const getDayClass = ({ date }) => {
    const diff = getDiffWithToday(date)
    if (diff === 0) {
      return 'uib-day--current'
    }
    if (!this.limitDate || this.limitDate === 'past') {
      return diff > 0 ? 'uib-day--normal' : 'uib-day--past'
    } else {
      return diff < 0 ? 'uib-day--normal' : 'uib-day--past'
    }
  }

  // angular-ui date picker `disabled` callback
  const getDateDisabled = ({ date }) => {
    if (!this.limitDate) {
      return false
    }
    const diff = getDiffWithToday(date)
    return (this.limitDate === 'past') === diff < 0
  }

  this.datePickerOptions = {
    showWeeks: false,
    maxMode: 'day',
    customClass: getDayClass,
    dateDisabled: getDateDisabled,
  }

  this.$onChanges = (changes) => {
    if (
      angular.isDefined(changes.stateRequest) &&
      angular.isDefined(changes.stateRequest.currentValue) &&
      changes.stateRequest.currentValue !== null
    ) {
      if (
        changes.stateRequest.currentValue.constructor ===
        new StateRequest('noop').constructor
      ) {
        if (changes.stateRequest.currentValue.state === 'close') {
          if (
            this.isOpen === true &&
            changes.stateRequest.currentValue.updateDatum === true
          ) {
            this.timeUpdate({}, this.time)
          }
          this.isOpen = false
          this.stateRequest = null
        }
      } else {
        console.error('Datatype Unhandled')
      }
    }
  }
}
